import { render, staticRenderFns } from "./my-drawer.vue?vue&type=template&id=4e4725e5&scoped=true"
import script from "./my-drawer.vue?vue&type=script&lang=js"
export * from "./my-drawer.vue?vue&type=script&lang=js"
import style0 from "./my-drawer.vue?vue&type=style&index=0&id=4e4725e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4725e5",
  null
  
)

export default component.exports